import React from 'react'

// router
import { withRouter } from 'react-router-dom'

import { motivoStockLabel } from '../../../utils/motivoStockLabel'
import { formatFechaArgentina } from '../../../utils/fechaArgentina'

const ItemHistorialStock = ({ stock }) => {
    return (
        <tr>
            <td>{stock.cantidadActual}</td>
            <td>{stock.cantidadNueva}</td>
            <td>{motivoStockLabel(stock.motivo)}</td>
            <td>{formatFechaArgentina(stock.createdAt)}</td>
        </tr>
    )
}

export default withRouter(ItemHistorialStock)
